/**
 * Category Form Modal Validation Schema
 * Zod schema for CategoryFormModal
 */

import { z } from 'zod';
import { DEFAULT_CATEGORY_COLOR } from '@/constants/categoryColorPresets';

export const categoryFormModalSchema = z.object({
  name: z
    .string()
    .min(1, 'vendor.categories.validation.nameRequired')
    .max(100, 'vendor.categories.validation.nameMax'),
  color: z
    .string()
    .regex(/^#[0-9A-F]{6}$/i, 'vendor.categories.validation.colorFormat')
    .default(DEFAULT_CATEGORY_COLOR),
  notes: z
    .string()
    .max(500, 'vendor.categories.validation.notesMax')
    .optional()
    .or(z.literal('')),
});

export type CategoryFormModalData = z.infer<typeof categoryFormModalSchema>;
